"use client";

import "./WebAppClientsSection.scss";

import LogoMarqueeSection from "@/components/LogoMarqueeSection/LogoMarqueeSection";
import herbal from "@/assets/images/brands/herbal.webp";
import pks from "@/assets/images/brands/psk_eng.webp";
import delta from "@/assets/images/brands/delta_brand.webp";
import dynamic from "@/assets/images/brands/dynamic.webp";
import kankriya from "@/assets/images/brands/kankriya.webp";
import toyota from "@/assets/images/brands/toyotalogo.webp";
import collman from "@/assets/images/brands/collman.webp";
import workflow from "@/assets/images/brands/workflow.webp";
import ojiholding from "@/assets/images/brands/oji_holding.webp";
import gpSolution from "@/assets/images/brands/gp_solution.webp";

const WebAppClientsSection = () => {
  const brands = [
    { src: toyota, alt: "Toyota" },
    { src: ojiholding, alt: "Oji Holding" },
    { src: collman, alt: "Collman" },
    { src: workflow, alt: "Workflow" },
    { src: dynamic, alt: "Dynamic" },
    { src: gpSolution, alt: "GPSolution" },
    { src: herbal, alt: "Herbal" },
    { src: delta, alt: "Delta" },
    { src: pks, alt: "Pks" },
    { src: kankriya, alt: "Kankriya" },
  ];
  return (
    <LogoMarqueeSection title="Loved by 25 Millions+ Users" brands={brands} />
  );
};

export default WebAppClientsSection;
